import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'lineasPedido',
})
export class LineasPedidoPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {
    if (filter && items) {

      if (filter['filtrar']) {

        items = items.filter(function (item) {
          return item.cerrada == filter['cerrada'];
        });

      }
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/lineas-pedido/lineas-pedido.ts